export const aggregateLocationInventory = (data, locationInventory) => {
  const pages = data?.pages;
  if (!pages) {
    return locationInventory;
  }
  locationInventory.location_id = pages[0].results.location_id;
  locationInventory.items = pages.flatMap(page => page.results.items);

  return locationInventory;
};
